module.exports = __webpack_public_path__ + "img/PG1_2-6-259x195.baf8defc.png";